import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  HEADER_HEIGHT,
  MAX_CONTENT_HEIGHT,
  MAX_MOBILE_CONTENT_HEIGHT,
  MAX_PAGE_HEIGHT,
  MAX_PAGE_WIDTH,
  MENU_WIDTH,
  PAGE_CONTAINER_HEADER_HEIGHT,
  WEB_CONTENT_WIDTH,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  pageWrapper: {
    position: 'relative',
    height: MAX_PAGE_HEIGHT,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageContainerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    maxWidth: `calc(${MAX_PAGE_WIDTH} - ${MENU_WIDTH} - 8px)`,

    [theme.breakpoints.down('md')]: {
      // width: MAX_PAGE_WIDTH,
      width: '100vw',
      maxWidth: 'unset',
      gap: 0,
    },
  },
  pageContainer: {
    position: 'relative',
    width: WEB_CONTENT_WIDTH, // `calc(${MAX_PAGE_WIDTH} - ${MENU_WIDTH} - 8px)`,
    [theme.breakpoints.down('md')]: {
      // width: MAX_PAGE_WIDTH,
      width: '100vw',
    },
    borderRadius: '10px',
  },
  headerMobileWrapper: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },

  headerWebWrapper: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  pageHeaderWrapper: {
    borderRadius: '0 0 4px 4px',
    overflow: 'hidden',
    // boxShadow: '5px 5px 4px 0px #00000040',

    [theme.breakpoints.down('md')]: {
      height: HEADER_HEIGHT,
    },
  },

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.header.contrastText,
    '& svg': {
      height: '32px',
      width: '32px',
    },
  },

  pageContainerContent: {
    height: MAX_CONTENT_HEIGHT,
    maxHeight: MAX_CONTENT_HEIGHT,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: theme.spacing(0.5),

    [theme.breakpoints.down('md')]: {
      height: MAX_MOBILE_CONTENT_HEIGHT,
      maxHeight: MAX_MOBILE_CONTENT_HEIGHT,
      padding: theme.spacing(0, 1),
    },
  },

  divider: {
    display: 'block',
    marginTop: theme.spacing(1),
    // boxShadow: '5px 5px 4px 0px #00000040',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  pageHeaderActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    flexShrink: 0,
  },

  pageContainerHeader: {
    backgroundColor: 'transparent',
    color: theme.palette.containerHeader.contrastText,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: PAGE_CONTAINER_HEADER_HEIGHT,
    // padding: theme.spacing(0, 2),

    [theme.breakpoints.down('md')]: {
      height: `calc(${HEADER_HEIGHT} - 5px)`,
      borderBottom: `1px solid ${theme.palette.border.main}`,
      marginBottom: '4px',
      color: theme.palette.header.contrastText,
      padding: theme.spacing(0, 1),

      // backgroundColor: theme.palette.header.main,
    },

    // '& svg': {
    //   color: theme.palette.primary.contrastText,
    //
    //   [theme.breakpoints.down('md')]: {
    //     color: theme.palette.header.contrastText,
    //   },
    // },
  },
  pageContainerTitle: {
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.15s linear',

    '& svg': {
      transition: 'color 0.15s linear',
      marginRight: '8px',
      color: theme.palette.text.primary,
    },
  },

  clickable: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
      '& svg': {
        color: theme.palette.primary.main,
      },
    },
  },

  title: {
    ...theme.mixins.appEllipsis,
  },
  description: {
    ...theme.mixins.appEllipsis,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));
